import { render } from "./resetPasword.vue?vue&type=template&id=30fde3ed"
import script from "./resetPasword.vue?vue&type=script&lang=js"
export * from "./resetPasword.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/resetPasword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30fde3ed"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30fde3ed', __exports__)) {
    api.reload('30fde3ed', __exports__)
  }
  
  module.hot.accept("./resetPasword.vue?vue&type=template&id=30fde3ed", () => {
    api.rerender('30fde3ed', render)
  })

}


export default __exports__